import React, { useEffect, useRef, useState } from "react";
import RightNavigation from "../Navigation/RightNavigation";
import { resume, header, Profile } from "../../config/imagesLink";
import axios from "../../API/axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import QRCode from "react-qr-code";
import EditNoteSharpIcon from '@mui/icons-material/EditNoteSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import PinDropSharpIcon from '@mui/icons-material/PinDropSharp';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import { createRoot } from "react-dom/client";
import ResumePdf from "./ResumePdf";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Button } from "react-bootstrap";
import DownloadSharpIcon from '@mui/icons-material/DownloadSharp';
import PlaceSharpIcon from '@mui/icons-material/PlaceSharp';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import MyLocationSharpIcon from '@mui/icons-material/MyLocationSharp';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import SupervisedUserCircleSharpIcon from '@mui/icons-material/SupervisedUserCircleSharp';
import WorkspacePremiumSharpIcon from '@mui/icons-material/WorkspacePremiumSharp';
import MilitaryTechSharpIcon from '@mui/icons-material/MilitaryTechSharp';
import PsychologySharpIcon from '@mui/icons-material/PsychologySharp';
import AttachFileSharpIcon from '@mui/icons-material/AttachFileSharp';
import PersonSharpIcon from '@mui/icons-material/PersonSharp';
import PhoneIphoneSharpIcon from '@mui/icons-material/PhoneIphoneSharp';
import SummarizeSharpIcon from '@mui/icons-material/SummarizeSharp';
import TitleSharpIcon from '@mui/icons-material/TitleSharp';
import SubtitlesSharpIcon from '@mui/icons-material/SubtitlesSharp';
import { ViewResumeSkeleton } from "@skeleton";
import SuccessToast from "../SuccessToast";
import { useTranslation } from "react-i18next";
import { getVisibleResumeItems } from "../../utility/profileVisibility";

const ViewResume = () => {
  const sessionId = localStorage.getItem("sessionId");
  const { UserId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const { t } = useTranslation();
  const [ccvInfo, setCCVInfo] = useState("");
  const [ccvEducation, setCCVEducation] = useState([]);
  const [ccvCertification, setCCVCertification] = useState([]);
  const [ccvAward, setCCVAward] = useState([]);
  const [ccvExperience, setCCVExperience] = useState([]);
  const [skills, setSkills] = useState([]);
  const [CCVAttachement, setCCVAttachement] = useState([]);
 
  const getUserProfile = () => {
  setIsLoading(true);
  setIsError(false); // Reset before making request

  const data = {
    deviceType: "Web",
    sessionId: sessionId,
    userUid: UserId,
  };

  axios
    .post(`Resume/GetUserResume`, data)
    .then((response) => {
      
      if (response.status === 204 || !response.data.responseData) {
        setIsError(true);
        setIsLoading(false);
        return;
      }

      const res = response.data.responseData;
      setCCVInfo(res?.resumeInfo);
      setCCVEducation(res?.resumeEducations || []);
      setCCVCertification(res?.resumeCertifications || []);
      setCCVAward(res?.resumeAwards || []);
      setCCVExperience(res?.resumeExperiences || []);
      setCCVAttachement(res?.resumeAttachments || []);
      setSkills(res?.resumeSkills || []);
      setIsLoading(false);
      
    })
    .catch((error) => {
      console.error("Error fetching user profile:", error);
      setIsError(true);
      setIsLoading(false);
    });
};

useEffect(() => {
    getUserProfile();
  }, [UserId]);

  // const downloadResume = async () => {
  //   try {
  //     const tempContainer = document.createElement("div");
  //     tempContainer.style.position = "absolute";
  //     tempContainer.style.left = "-9999px";
  //     document.body.appendChild(tempContainer);

  //     const root = createRoot(tempContainer);
  //     root.render(
  //       <ResumePdf
  //         ccvInfo={ccvInfo}
  //         ccvEducation={ccvEducation}
  //         ccvCertification={ccvCertification}
  //         ccvAward={ccvAward}
  //         ccvExperience={ccvExperience}
  //         CCVAttachement={CCVAttachement}
  //         skills={skills}
  //         UserId={UserId}
  //       />
  //     );

  //     setTimeout(async () => {
  //       try {
  //         const canvas = await html2canvas(tempContainer, {
  //           scale: 1.5,
  //           useCORS: true,
  //           logging: true,
  //           allowTaint: true,
  //         });

  //         const pdf = new jsPDF("portrait", "pt", "a4");
  //         const pdfWidth = pdf.internal.pageSize.getWidth();
  //         const imgWidth = pdfWidth - 40;
  //         const pageHeight = pdf.internal.pageSize.getHeight() - 40;

  //         let yOffset = 0;

  //         while (yOffset < canvas.height) {
  //           const portionCanvas = document.createElement("canvas");
  //           portionCanvas.width = canvas.width;
  //           portionCanvas.height = Math.min(pageHeight * (canvas.width / imgWidth), canvas.height - yOffset);

  //           const portionContext = portionCanvas.getContext("2d");
  //           portionContext.drawImage(
  //             canvas,
  //             0,
  //             yOffset,
  //             canvas.width,
  //             portionCanvas.height,
  //             0,
  //             0,
  //             canvas.width,
  //             portionCanvas.height
  //           );

  //           const portionImgData = portionCanvas.toDataURL("image/png");
  //           pdf.addImage(
  //             portionImgData,
  //             "PNG",
  //             20,
  //             20,
  //             imgWidth,
  //             (portionCanvas.height * imgWidth) / canvas.width
  //           );

  //           yOffset += portionCanvas.height;
  //           if (yOffset < canvas.height) {
  //             pdf.addPage();
  //           }
  //         }

  //         const userName = ccvInfo.fullName || "Resume";
  //         const fileName = `${userName}_Resume.pdf`;
  //         pdf.save(fileName);
  //       } catch (error) {
  //         console.error("Error generating PDF:", error.message);
  //       } finally {
  //         root.unmount();
  //         document.body.removeChild(tempContainer);
  //       }
  //     }, 2000);
  //   } catch (error) {
  //     console.error("Error generating PDF:", error.message);
  //   }
  // };


  // const downloadResume = async () => {
  //   try {
  //     // Create a hidden container for rendering the Resume component
  //     const tempContainer = document.createElement("div");
  //     tempContainer.style.position = "absolute";
  //     tempContainer.style.left = "-9999px";
  //     // tempContainer.style.width = "210mm"; // A4 size in mm
  //     tempContainer.style.minHeight = "297mm"; // A4 size in mm
  //     document.body.appendChild(tempContainer);


  //     let userImageBase64 = "/path/to/default-avatar.png";
	// 		if (ccvInfo?.userImage) {
	// 			console.log("Fetching image:", ccvInfo.userImage);
	// 			try {
	// 				userImageBase64 = await fetchImageAsBase64(ccvInfo.userImage);
	// 				console.log("User image converted to Base64 successfully!");
	// 			} catch (error) {
	// 				console.warn("Failed to load user image:", error.message);
	// 			}
	// 		}

  //     const root = createRoot(tempContainer);
  //     root.render(
  //       <ResumePdf
  //         ccvInfo={ccvInfo}
  //         ccvEducation={ccvEducation}
  //         ccvCertification={ccvCertification}
  //         ccvAward={ccvAward}
  //         ccvExperience={ccvExperience}
  //         CCVAttachement={CCVAttachement}
  //         skills={skills}
  //         UserId={UserId}
  //       />
  //     );

  //     setTimeout(async () => {
  //       try {
  //         // Generate the canvas from the rendered component
  //         const canvas = await html2canvas(tempContainer, {
  //           scale: 2, // Higher resolution for better PDF quality
  //           useCORS: true,
  //         });

  //         const pdf = new jsPDF("portrait", "pt", "a4");
  //         const pdfWidth = pdf.internal.pageSize.getWidth();
  //         const pdfHeight = pdf.internal.pageSize.getHeight();

  //         const imgWidth = pdfWidth - 40;
  //         const pageHeight = pdfHeight - 40;

  //         let yOffset = 0;

  //         // Split content into pages
  //         while (yOffset < canvas.height) {
  //           // Check if we are starting a new section (e.g., "Attachment")
  //           const isAttachment = yOffset > canvas.height - 300; // Adjust based on content height
  //           const sliceHeight = isAttachment
  //             ? pageHeight // Full page for "Attachment"
  //             : Math.min(pageHeight * (canvas.width / imgWidth), canvas.height - yOffset);

  //           const portionCanvas = document.createElement("canvas");
  //           portionCanvas.width = canvas.width;
  //           portionCanvas.height = sliceHeight;

  //           const context = portionCanvas.getContext("2d");
  //           context.drawImage(
  //             canvas,
  //             0,
  //             yOffset,
  //             canvas.width,
  //             sliceHeight,
  //             0,
  //             0,
  //             canvas.width,
  //             sliceHeight
  //           );

  //           const imgData = portionCanvas.toDataURL("image/png");
  //           pdf.addImage(
  //             imgData,
  //             "PNG",
  //             20,
  //             20,
  //             imgWidth,
  //             (sliceHeight * imgWidth) / canvas.width
  //           );

  //           yOffset += sliceHeight;
  //           if (yOffset < canvas.height) {
  //             pdf.addPage();
  //           }
  //         }

  //         // Save the PDF
  //         const userName = ccvInfo.fullName || "Resume";
  //         const fileName = `${userName}_Resume.pdf`;
  //         pdf.save(fileName);
  //       } catch (error) {
  //         console.error("Error generating PDF:", error.message);
  //       } finally {
  //         // Clean up the temporary container
  //         root.unmount();
  //         document.body.removeChild(tempContainer);
  //       }
  //     }, 2000);
  //   } catch (error) {
  //     console.error("Error generating PDF:", error.message);
  //   }
  // };

  // const fetchImageAsBase64 = async (url) => {
	// 	try {
	// 		console.log("Fetching image from URL:", url);

	// 		// Use a proxy if needed
	// 		const proxyUrl = "https://api.allorigins.win/raw?url=";
	// 		const response = await fetch(proxyUrl + encodeURIComponent(url));

	// 		if (!response.ok) {
	// 			throw new Error(`Failed to fetch image. Status: ${response.status}`);
	// 		}

	// 		const blob = await response.blob();
	// 		return new Promise((resolve) => {
	// 			const reader = new FileReader();
	// 			reader.onloadend = () => resolve(reader.result);
	// 			reader.readAsDataURL(blob);
	// 		});
	// 	} catch (error) {
	// 		console.error("Error fetching image:", error.message);
	// 		return "/path/to/default-avatar.png"; // Fallback image
	// 	}
	// };

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);
	const isDownloadingRef = useRef(false); // Ref to track download state
  const pdfLogoBase64Cache = useRef(null);

  const PDF_QR_RENDER_PX = 320;
  const PDF_CAPTURE_SCALE = 1.4;
  const PDF_JPEG_QUALITY = 0.72;
  const PDF_IMAGE_PROXY_TIMEOUT_MS = 8000;
  const PDF_IMAGE_DIRECT_TIMEOUT_MS = 2000;
  const PDF_HTML2CANVAS_IMAGE_TIMEOUT_MS = 1500;

  const blobToDataUrl = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("Failed to read image blob"));
      reader.readAsDataURL(blob);
    });

  const getHtml2canvasPdfOptions = (overrides = {}) => ({
    scale: PDF_CAPTURE_SCALE,
    useCORS: true,
    taintTest: false,
    imageTimeout: PDF_HTML2CANVAS_IMAGE_TIMEOUT_MS,
    logging: false,
    ...overrides,
  });

  const getImageElementAsBase64 = (imgEl) => {
    if (!imgEl?.complete || !imgEl.naturalWidth) {
      return null;
    }

    try {
      const canvas = document.createElement("canvas");
      canvas.width = imgEl.naturalWidth;
      canvas.height = imgEl.naturalHeight;
      canvas.getContext("2d").drawImage(imgEl, 0, 0);
      return canvas.toDataURL("image/png");
    } catch {
      return null;
    }
  };

  const fetchImageDirectAsBase64 = async (url) => {
    if (!url || String(url).startsWith("data:")) {
      return url || null;
    }

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(
        () => controller.abort(),
        PDF_IMAGE_DIRECT_TIMEOUT_MS
      );
      const response = await fetch(url, {
        signal: controller.signal,
        mode: "cors",
      });
      clearTimeout(timeoutId);

      if (!response.ok) {
        return null;
      }

      return await blobToDataUrl(await response.blob());
    } catch {
      return null;
    }
  };

  const resolvePdfLogoBase64 = async () => {
    if (pdfLogoBase64Cache.current) {
      return pdfLogoBase64Cache.current;
    }

    const directLogo = await fetchImageDirectAsBase64(header.WeLinkWhite);
    if (directLogo?.startsWith("data:")) {
      pdfLogoBase64Cache.current = directLogo;
      return directLogo;
    }

    const visibleLogo = document.querySelector(".user-resume .resume-logo img");
    const cachedLogo = getImageElementAsBase64(visibleLogo);
    if (cachedLogo?.startsWith("data:")) {
      pdfLogoBase64Cache.current = cachedLogo;
      return cachedLogo;
    }

    return null;
  };

  const preparePdfImages = async (container, userImageBase64, logoBase64) => {
    const profileImg = container.querySelector(".resume-profile-image img");
    if (profileImg && userImageBase64?.startsWith("data:")) {
      profileImg.src = userImageBase64;
    }

    const logoImg = container.querySelector(".resume-logo img");
    if (!logoImg) {
      return;
    }

    if (logoBase64?.startsWith("data:")) {
      logoImg.src = logoBase64;
      return;
    }

    logoImg.style.display = "none";
  };

  const generateSharpQrPng = async (url) => {
    const container = document.createElement("div");
    container.style.cssText =
      "position:absolute;left:-9999px;top:0;background:#ffffff;padding:0;line-height:0;";
    document.body.appendChild(container);

    const qrRoot = createRoot(container);
    qrRoot.render(
      <QRCode
        value={url}
        size={PDF_QR_RENDER_PX}
        level="M"
        bgColor="#FFFFFF"
        fgColor="#000000"
      />
    );

    await new Promise((resolve) => setTimeout(resolve, 200));

    const canvas = await html2canvas(container, {
      scale: 1,
      backgroundColor: "#ffffff",
      useCORS: true,
      imageTimeout: PDF_HTML2CANVAS_IMAGE_TIMEOUT_MS,
      logging: false,
    });

    qrRoot.unmount();
    document.body.removeChild(container);
    return canvas.toDataURL("image/png");
  };

  const downloadResume = async () => {
    if (isDownloadingRef.current) return;

    setIsDownloading(true);
    isDownloadingRef.current = true;

      //  Show custom toast
  setToastMessage("Downloading resume...");
  setShowToast(true);

    let tempContainer = null;
    let root = null;

    try {
        tempContainer = document.createElement("div");
        tempContainer.style.position = "absolute";
        tempContainer.style.left = "-9999px";
        tempContainer.style.width = "794px";
        tempContainer.style.webkitFontSmoothing = "antialiased";
        tempContainer.style.MozOsxFontSmoothing = "grayscale";
        document.body.appendChild(tempContainer);

        root = createRoot(tempContainer);

        const userImagePromise = ccvInfo?.userImage
          ? fetchImageAsBase64(ccvInfo.userImage).catch((error) => {
              console.warn("Failed to load user image:", error.message);
              return "/path/to/default-avatar.png";
            })
          : Promise.resolve("/path/to/default-avatar.png");

        root.render(
            <div id="pdfContent" style={{ color: "black", width: "100%" }}>
                <ResumePdf
                    ccvInfo={{ ...ccvInfo, userImage: ccvInfo?.userImage }}
                    ccvEducation={ccvEducation}
                    ccvCertification={ccvCertification}
                    ccvAward={ccvAward}
                    ccvExperience={ccvExperience}
                    CCVAttachement={CCVAttachement}
                    skills={skills}
                    UserId={UserId}
                    isLoading={isLoading}
                />
            </div>
        );

        const [userImageBase64, logoBase64] = await Promise.all([
          userImagePromise,
          resolvePdfLogoBase64(),
          new Promise((resolve) => setTimeout(resolve, 1500)),
        ]);

        await preparePdfImages(tempContainer, userImageBase64, logoBase64);

        const sections = tempContainer.querySelectorAll(".pdf-section");
        const pdf = new jsPDF("portrait", "pt", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth() - 40;
        const pdfHeight = pdf.internal.pageSize.getHeight() - 40;
        let currentY = 20;

        pdf.setLineHeightFactor(1.5);

        const qrPdfUrl = `https://welinkjobs.com/Resume/${UserId}`;
        let sharpQrPng = null;

        for (let i = 0; i < sections.length; i++) {
          const section = sections[i];
          // Prevent breaking across pages
          section.style.pageBreakInside = "avoid";
          section.style.breakInside = "avoid";
          section.style.webkitColumnBreakInside = "avoid";

          section.style.webkitFontSmoothing = "antialiased";
          section.style.textRendering = "optimizeLegibility";

          // Adjust list styles for better rendering
          section.querySelectorAll("ul, ol").forEach((list) => {
            list.style.paddingLeft = "20px";
            list.style.paddingBottom = "4px";
            list.style.listStylePosition = "inside";
          });

          const qrWrapper = section.querySelector(".pdf-qr-code");
          let qrPlacement = null;

          if (qrWrapper) {
            if (!sharpQrPng) {
              sharpQrPng = await generateSharpQrPng(qrPdfUrl);
            }
            const sectionRect = section.getBoundingClientRect();
            const qrRect = qrWrapper.getBoundingClientRect();
            if (sectionRect.width > 0 && sectionRect.height > 0) {
              qrPlacement = {
                relX: (qrRect.left - sectionRect.left) / sectionRect.width,
                relY: (qrRect.top - sectionRect.top) / sectionRect.height,
                relW: qrRect.width / sectionRect.width,
                relH: qrRect.height / sectionRect.height,
              };
            }
            qrWrapper.style.visibility = "hidden";
          }

          try {
            const sectionCanvas = await html2canvas(section, {
              scrollY: -window.scrollY,
              ...getHtml2canvasPdfOptions(),
            });

            if (qrWrapper) {
              qrWrapper.style.visibility = "";
            }

            const sectionHeight = (sectionCanvas.height * pdfWidth) / sectionCanvas.width;

            if (currentY + sectionHeight > pdfHeight || section.classList.contains("page-break")) {
              if (i > 0) { // Don't add page before first section
                pdf.addPage();
                currentY = 20;
              }
            }

            const imgData = sectionCanvas.toDataURL("image/jpeg", PDF_JPEG_QUALITY);

            if (imgData && imgData.startsWith("data:image/jpeg")) {
              pdf.addImage(imgData, "JPEG", 20, currentY, pdfWidth, sectionHeight);

              if (qrPlacement && sharpQrPng) {
                const qrW = qrPlacement.relW * pdfWidth;
                const qrH = qrPlacement.relH * sectionHeight;
                const qrX = 20 + qrPlacement.relX * pdfWidth;
                const qrY = currentY + qrPlacement.relY * sectionHeight;
                pdf.addImage(sharpQrPng, "PNG", qrX, qrY, qrW, qrH);
              }

              currentY += sectionHeight + 10;
            } else {
              console.warn("Skipping invalid or corrupt image.");
            }
          } catch (imgError) {
            if (qrWrapper) {
              qrWrapper.style.visibility = "";
            }
            console.warn("Error processing image:", imgError.message);
          }
        }

        const userName = ccvInfo?.fullName || "Resume";
        const fileName = `${userName} Resume.pdf`;
        pdf.save(fileName);

        setToastMessage("Resume downloaded successfully!");
    } catch (error) {
        console.error("Error generating resume:", error.message);
        setToastMessage("Failed to download resume.")
    } finally {
        if (root) {
            root.unmount();
        }
        if (tempContainer) {
            document.body.removeChild(tempContainer);
        }
        setIsDownloading(false);
        isDownloadingRef.current = false;
        //  Hide toast after 3 seconds
        setTimeout(() => {
          setShowToast(false);
        }, 3000);
        }
};
         
	const fetchImageAsBase64 = async (url) => {
		if (!url) {
			return "/path/to/default-avatar.png";
		}

		if (String(url).startsWith("data:")) {
			return url;
		}

		try {
			const controller = new AbortController();
			const timeoutId = setTimeout(
				() => controller.abort(),
				PDF_IMAGE_PROXY_TIMEOUT_MS
			);

			const proxyUrl = "https://api.allorigins.win/raw?url=";
			const response = await fetch(proxyUrl + encodeURIComponent(url), {
				signal: controller.signal,
			});
			clearTimeout(timeoutId);

			if (!response.ok) {
				throw new Error(`Failed to fetch image. Status: ${response.status}`);
			}

			return await blobToDataUrl(await response.blob());
		} catch (error) {
			console.error("Error fetching image:", error.message);
			return "/path/to/default-avatar.png";
		}
	};

  const visibleEducation = getVisibleResumeItems(ccvEducation);
  const visibleExperience = getVisibleResumeItems(ccvExperience);
  const visibleCertification = getVisibleResumeItems(ccvCertification);
  const visibleAwards = getVisibleResumeItems(ccvAward);
  const visibleSkills = getVisibleResumeItems(skills);
  const visibleAttachments = getVisibleResumeItems(CCVAttachement);

  return (
    <>
      {
      isLoading ? (
        <ViewResumeSkeleton className="mt-3" />
      ):
        isError ? (
          <h5 className="mt-5 d-flex justify-content-center">
            No Data Available
          </h5>
        ) :
         (
          <div className="user-resume UpdateProfile pdf" style={{pageBreakAfter:"always !important"}}>
            <div className="resume-header d-flex align-items-center px-3 py-3">
              <div className="resume-profile-image">
                <img src={ccvInfo?.userImage} alt="" srcset=""  />
              </div>
              <div className="resumeHeader ms-3">
                <h3>{ccvInfo?.fullName}</h3>
                <div className="uid">
                  <span className="activeIcon"></span>
                  <h4 className="ms-3 mb-0">{ccvInfo?.userUid}</h4>
                </div>
              </div>
              <div
                className="d-flex ms-auto align-items-center"
                style={{ gap: "10px", flexShrink: 0 }}
              >
               <div className="resume-logo weLinkImage d-flex align-items-center">
                  <img src={header.WeLinkWhite} alt="" srcset="" />
                </div>
                <div
                  style={{
                    width: "54px",
                    height: "54px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #ffffff",
                    backgroundColor: "#ffffff",
                    flexShrink: 0,
                    boxSizing: "border-box",
                  }}
                >
                  <QRCode
                    value={`https://welinkjobs.com/Resume/${UserId}`}
                    size={50}
                    level="M"
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                  />
                </div>
                <DownloadSharpIcon 
                onClick={downloadResume} 
                disabled={isDownloading}  
													style={{
                            color: 'white', 
														cursor: isDownloading ? "not-allowed" : "pointer",
														backgroundColor: isDownloading ? "grey" : "",
														opacity: isDownloading ? 0.6 : 1
													}}
                className='pointer ms-2'  />
              </div>
            </div>
            {(visibleEducation.length === 0 || visibleExperience.length === 0) && (
              <p className="warningText"> Warning: Incomplete Resume.</p>
            )}
            <div className="row border-custom2">
                {ccvInfo?.title &&
                  <div className="col-md-6 border-custom">
                      <div
                        className={`analytic-sub mt-2 mb-1  pb-2`}
                      >
                        <div className="d-flex align-items-start justify-content-between">
                          <div className="ms-2">
                            <div className="d-flex verified">
                              <SubtitlesSharpIcon className="HeadingIcon material-symbols-sharp" />
                              <p className="f-12 ms-1 pb-1  me-2">
                                {t("User Profile.Title")}
                              </p>
                            </div>
                            <p className="ms-4 f-14 fw-bold">
                              {ccvInfo?.title}
                            </p>
                          </div>
                        </div>
                      </div>
                  </div>
                }
                {ccvInfo?.email &&
                <div className="col-md-6 border-custom">
                    <div
                      className={`analytic-sub mt-2 mb-1  pb-2`}
                    >
                      <div className="d-flex align-items-start justify-content-between">
                        <div className="ms-2">
                          <div className="d-flex verified">
                            <MailOutlineSharpIcon className="HeadingIcon material-symbols-sharp" />
                            <p className="f-12 ms-1 pb-1  me-2">
                              {t("User Profile.Email")}
                            </p>
                          </div>
                          <p className="ms-4 f-14 fw-bold">
                            {ccvInfo?.email}
                          </p>
                        </div>
                      </div>
                    </div>
                </div>
                }
            {/* </div> */}
            {/* <div className="row border-custom2"> */}
                {ccvInfo?.dob &&
                <div className="col-md-6 border-custom">
                    <div
                      className={`analytic-sub mt-2 mb-1 pb-2`}
                    >
                      <div className="d-flex align-items-start justify-content-between">
                        <div className="ms-2">
                          <div className="d-flex verified">
                            <CalendarMonthSharpIcon className="HeadingIcon material-symbols-sharp" />
                            <p className="f-12 ms-1 pb-1  me-2">
                              {t("User Profile.DOB")}
                            </p>
                          </div>
                          <p className="ms-4 f-14 fw-bold">
                            {moment(ccvInfo?.dob).format("DD MMM YYYY")}
                          </p>
                        </div>
                      </div>
                    </div>
                </div>
                }
                 {ccvInfo?.nationalityCountry &&
                <div className="col-md-6 border-custom">
                    <div
                      className={`analytic-sub mt-2 mb-1 pb-2`}
                    >
                      <div className="d-flex align-items-start justify-content-between">
                        <div className="ms-2">
                          <div className="d-flex verified">
                            <MyLocationSharpIcon className="HeadingIcon material-symbols-sharp" />
                            <p className="f-12 ms-1 pb-1  me-2">
                              {t("User Profile.Nationality (Country)")}
                            </p>
                          </div>
                          <p className="ms-4 f-14 fw-bold">
                            {ccvInfo?.nationalityCountry}
                          </p>
                        </div>
                      </div>
                    </div>
                </div>
                }
                {ccvInfo?.currentCity &&
                <div className="col-md-6 border-custom">
                    <div
                      className={`analytic-sub mt-2 mb-1 pb-2`}
                    >
                      <div className="d-flex align-items-start justify-content-between">
                        <div className="ms-2">
                          <div className="d-flex verified">
                            <MyLocationSharpIcon className="HeadingIcon material-symbols-sharp" />
                            <p className="f-12 ms-1 pb-1  me-2">
                              {t("User Profile.City")}
                            </p>
                          </div>
                          <p className="ms-4 f-14 fw-bold">
                            {ccvInfo?.currentCity}
                          </p>
                        </div>
                      </div>
                    </div>
                </div>
                }
            {/* </div> */}

            {/* <div className="row border-custom2">        */}
                  {ccvInfo?.phoneNumber &&
                    <div className="col-md-6  ">
                        <div
                          className={`analytic-sub mt-2 mb-1 pb-2`}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="ms-2">
                              <div className="d-flex verified">
                                <PhoneIphoneSharpIcon className="HeadingIcon material-symbols-sharp" />
                                <p className="f-12 ms-1 pb-1 me-2">
                                  {t("User Profile.Phone Number")}
                                </p>
                              </div>
                              <p className="ms-4 f-14 fw-bold ">
                                +{ccvInfo.phoneCode}-{ccvInfo?.phoneNumber}
                              </p>
                            </div>
                          </div>
                        </div>
                    </div>
                  }
                  {ccvInfo?.webSiteLink &&
                    <div className="col-md-6  ">
                        <div
                          className={`analytic-sub mt-2 mb-1 pb-2`}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="ms-2">
                              <div className="d-flex verified">
                                <LanguageSharpIcon className="HeadingIcon material-symbols-sharp" />
                                <p className="f-12 ms-1 pb-1 me-2">
                                  {t("User Profile.Website")}
                                </p>
                              </div>
                              <p className="ms-4 f-14 fw-bold "> 
                                  <a
                                    className="f-14 fw-bold"
                                    href={
                                      ccvInfo?.webSiteLink?.startsWith('http://') ||
                                      ccvInfo?.webSiteLink?.startsWith('https://')
                                        ? ccvInfo?.webSiteLink
                                        : `http://${ccvInfo?.webSiteLink}`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                     class="website-link"
                                  >
                                  {ccvInfo?.webSiteLink}
                                </a> 
                              </p>
                            </div>
                          </div>
                        </div>
                    </div>
                  }
                {/* {ccvInfo?.webSiteLink &&
                  <div className="col-md-6  ">
                    <div
                      className={`analytic-sub mt-2 mb-1  pb-3`}
                    >

                      <div className="d-flex align-items-start justify-content-between">
                        <div className="ms-2">
                          <div className="d-flex verified">
                            <LanguageSharpIcon className="HeadingIcon material-symbols-sharp" />
                            <p className="f-12 ms-1 pb-1  me-2">
                              Website
                            </p>
                          </div>
                          <span className="ms-4 ">
                          <a
                            className="f-14 fw-bold"
                            href={
                              ccvInfo?.webSiteLink?.startsWith('http://') ||
                               ccvInfo?.webSiteLink?.startsWith('https://')
                                ? ccvInfo?.webSiteLink
                                : `http://${ccvInfo?.webSiteLink}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {ccvInfo?.webSiteLink}
                          </a>
                            </span>
                        </div>

                      </div>
                    </div>
                  </div>
                } */}
            </div>
            {/* <div className="row border-custom2"> */}
            
            
             {/* <div className="col-md-6">
                {ccvInfo?.title &&
                  <div
                    className={`analytic-sub mt-2 mb-1  pb-3`}
                  >
                    <div className="d-flex align-items-start justify-content-between">
                      <div className="ms-2">
                        <div className="d-flex verified">
                          <SubtitlesSharpIcon className="HeadingIcon material-symbols-sharp" />
                          <p className="f-14 ms-1 pb-1 fw-bold me-2">
                            Title
                          </p>
                        </div>
                        <p className="ms-1 f-12">
                          {ccvInfo?.title}
                        </p>
                      </div>
                    </div>
                  </div>
                }
              </div> */}
              {/* </div> */}
            {ccvInfo?.summary &&
              <div
                className={`analytic-sub mt-2 mb-1 pb-3 ps-3 pe-3`}
              >
                <div className="d-flex align-items-start justify-content-between">
                  <div className="ms-2">
                    <div className="d-flex verified">
                      <SummarizeSharpIcon className="HeadingIcon material-symbols-sharp" />
                      <p className="f-14 ms-1 pb-1 fw-bold me-2">
                        {t("User Profile.Summary")}
                      </p>
                    </div>

                    <p className="ms-1 f-12 me-2"  style={{textAlign:"justify"}}>
                      {ccvInfo?.summary}
                    </p>
                  </div>

                </div>
              </div>
            }
            {visibleEducation.length === 0 ? '' :
              <div className="UpdateProfile pb-0 p-3 page-break" >
                <div className="d-flex justify-content-between mb-2 border-custom2 pb-2">
                  <div className="d-flex">
                    <SchoolOutlinedIcon className="HeadingIcon material-symbols-sharp" />
                    <p className="f-16 fw-bold ms-1">{t("User Profile.Education")}</p>
                  </div>
                </div>
                {visibleEducation.map((item, index) => {
                      const isLastItem = index === visibleEducation.length - 1;
                      
                      return (

                        <div
                          className={`page-break analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom1"
                            } pb-3 ${item?.status === 0 ? 'disableText' : ''}`}
                          key={index}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="ms-2">
                              <div className="d-flex verified">
                              <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                <p className="f-14 ms-1 fw-bold me-2">
                                  {item.institutionName && (
                                    <>
                                      {item.institutionName}
                                      {/* {item?.isOrgVrfd === true ? (
                                        <img src={resume.verified} width={18} height={18} className="ms-1" />
                                      ) : item?.isOrgRgd === true ? (
                                        <img src={resume.register} width={18} height={18} className="ms-1" />
                                      ) : (
                                        <img src={resume.unregister} width={18} height={18} className="ms-1" />
                                      )} */}
                                      {/* {item?.isInstitutionDelete && <img src={resume.deleted} width={15} height={15} />} */}
                                    </>
                                  )}
                                </p>
                              </div>
                              <div className="ms-2">
                                <div className="d-flex">
                                  {item.field && <p className=" me-1 f-14 fw-bold">{t("User Profile.Field")}: {item.field}</p>}
                                  {item.field && <div className="dot"></div>}
                                  {item.degree && <p className="ms-2 f-14 fw-bold">{item.degree}</p>}
                                </div>
                                {item.activities && <p className="f-12">{t("User Profile.Activity")}: {item.activities}</p>}
                                {item.grade && <p className="f-12">{t("User Profile.Grade")}: {item.grade}</p>}
                                {item.description && <p className="f-12 fst-italic">{item.description}</p>}
                                <div className="d-flex align-items-center">
                                  {item.cityName && (
                                    <>
                                      <PlaceSharpIcon className="material-symbols-sharp locationIcon" />
                                      <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                      <div className="dot"></div>
                                      <p className="ms-2 f-12">
                                        ({moment(item.startYear).format("DD MMM YYYY")} - {item.isPresent === true ? "Present" : moment(item.endYear).format("DD MMM YYYY")})
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      );
                    })}
              </div>}

            {visibleExperience.length === 0 ? '' :
              <div className="UpdateProfile pb-0 p-3 page-break">
                <div className="d-flex justify-content-between mb-2 border-custom2 ">
                  <div className="d-flex">
                    <BusinessCenterOutlinedIcon className="HeadingIcon material-symbols-sharp" />
                    <p className="f-16 fw-bold ms-1">{t("User Profile.Experience")}</p>
                  </div>
                </div>
                {visibleExperience.map((item, index) => {
                      const isLastItem = index === visibleExperience.length - 1;
                      return (
                        <div
                          className={`page-break analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom1"
                            } pb-3 ${item?.status === 0 ? 'disableText' : ''}`}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="ms-2">
                              <div className="d-flex verified">
                              <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                <p className="f-14 ms-1 fw-bold me-2">
                                  {item.jobTitle && (
                                    <>
                                      {item.jobTitle}
                                      {/* {item?.isOrgVrfd === true ? (
                                        <img src={resume.verified} width={18} height={18} className="ms-1" />
                                      ) : item?.isOrgRgd === true ? (
                                        <img src={resume.register} width={18} height={18} className="ms-1" />
                                      ) : (
                                        <img src={resume.unregister} width={18} height={18} className="ms-1" />
                                      )}
                                      {item?.isInstitutionDelete && <img src={resume.deleted} width={15} height={15} />} */}
                                    </>
                                  )}
                                </p>
                              </div>
                              <div className="ms-2">
                                {item.companyName && <p className=" me-1 f-14 fw-bold">{item.companyName}</p>}
                                <div className="d-flex align-items-center">
                                  {item.jobTypeName && <p className=" me-2 f-12">{item.jobTypeName}</p>}
                                  {item.cityName && (
                                    <>
                                      <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                                      <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                      <div className="dot"></div>
                                      <p className="ms-2 f-12">
                                        ({moment(item.startDate).format("DD MMM YYYY")} - {item.isPresent === true ? "Present" : moment(item.endDate).format("DD MMM YYYY")})
                                      </p>
                                    </>
                                  )}
                                </div>
                                {item.positionHeadline && <p className="f-12">{item.positionHeadline}</p>}
                                {item.description && <p className="f-12 fst-italic">{item.description}</p>}
                              </div>
                            </div>
                          </div>
                          {item.rsmExperienceAchievements.length === 0 ? '' : <div className="mt-3 ARCard">
                            <div className="d-flex justify-content-between border-custom2">
                              <div className=" d-flex mb-1">
                                <EmojiEventsOutlinedIcon className="HeadingIcon material-symbols-sharp" style={{ marginTop: '1px' }}  />
                                <h6 className="f-14 ms-1 mb-0 f-600 mt-1">
                                 {t("User Profile.Experience Achievement")}
                                </h6>
                              </div>
                            </div>

                            {item.rsmExperienceAchievements &&
                              item.rsmExperienceAchievements
                                .filter((item) => !item.isDeleted)
                                ?.map((roleItem, index) => {
                                   const isLastItem = index === item.rsmExperienceAchievements.length - 1;
                                  return (
                                    <div
                                      className="d-flex align-items-start justify-content-between mt-1"
                                      key={index}
                                    >
                                      <div className="ms-2">
                                        <div className="d-flex verified">
                                         <p className="f-16 me-1">{index + 1}.</p>                       
                                          <p className="f-14 ms-1  me-2 m-0">
                                              {roleItem.achievement}
                                              <span className="f-12 text-dark ms-1">
                                                 {roleItem.achivementDate === "" ? "" : (
                                                 <>
                                                ({moment(roleItem.achivementDate).format("DD MMM YYYY")})
                                                  </>
                                               )}
                                                </span>
                                             </p>
                                        </div>
                                        {/* <p className="f-14 ms-1 me-2 m-0">
                                          {roleItem.achivementDate}
                                        </p> */}
                                      </div>
                                    </div>
                                  );
                                })}
                          </div>}
                          {item.rsmExperienceRoles.length === 0 ? '' : <div className="mt-3 ARCard">
                            <div className="d-flex justify-content-between border-custom2">
                              <div className="d-flex mb-1" >
                                <SupervisedUserCircleSharpIcon className="HeadingIcon material-symbols-sharp"  style={{ marginTop: '1px' }} />
                                <h6 className="f-14 ms-1 mb-0 f-600 mt-1">
                                  {t("User Profile.Responsibilities")}
                                </h6>
                              </div>
                            </div>

                            {item.rsmExperienceRoles &&
                              item.rsmExperienceRoles
                                .filter((item) => !item.isDeleted)
                                ?.map((roleItem, index) => {
                                   const isLastItem = index === item.rsmExperienceRoles.length - 1;

                                  return (
                                    <div
                                      className=" d-flex align-items-start justify-content-between mt-1"
                                      key={index}
                                    >
                                      <div className="ms-2">
                                        <div className="d-flex verified">
                                        <p className="f-16 me-1">{index + 1}.</p>
                                          <p className="f-14 ms-1 me-2 m-0">
                                            {roleItem.role}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                          </div>}

                        </div>
                      );
                    })}
              </div>
            }

            {visibleCertification.length === 0 ? '' :
              <div className="UpdateProfile pb-0 p-3 page-break">
                <div className="d-flex justify-content-between mb-2 border-custom2 pb-2">
                  <div className="d-flex">
                    <WorkspacePremiumSharpIcon className="HeadingIcon material-symbols-sharp" />
                    <p className="f-16 fw-bold ms-1">{t("User Profile.Certification")}</p>
                  </div>
                </div>
                {/* <div className='analytics d-flex justify-content-between mt-3'> */}
                {/* ccvCertifications */}
                {visibleCertification.map((item, index) => {
                      const isLastItem = index === visibleCertification.length - 1;
                      return (

                        <div
                          className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : 
                            "border-custom1"
                            } pb-3 ${item?.status === 0 ? 'disableText' : ''}`}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            {/* <img src={NewsFeed.companyLogo} alt="" width={40} height={40} /> */}
                            <div className="ms-2">
                              <div className="d-flex verified">
                              <p className="f-16 fw-bold me-1">{index + 1}.</p>

                                <p className="f-14 ms-1 fw-bold me-2">
                                  {item.name && (
                                    <>
                                      {item.name}
                                    </>
                                  )}
                                </p>
                              </div>
                              <div className="ms-2">
                                {item.orgName && <p className=" me-1 f-14 fw-bold">{item.orgName}</p>}
                                <div className="d-flex align-items-center">
                                  {item.recognition && <p className=" me-1 f-12">{item.recognition}</p>}
                                  {item.credentialId && (
                                    <>
                                      <div className="dot"></div>
                                      <p className="ms-2 f-12">ID: {item.credentialId}</p>
                                    </>
                                  )}
                                </div>
                                <div className="d-flex align-items-center">
                                  {item.cityName && (
                                    <>
                                      <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                                      <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                      <div className="dot"></div>
                                      {/* <p className="ms-2 f-12">
                                        ({moment(item.issueDate).format("YYYY")} - {moment(item.expirationDate).format("YYYY")})
                                      </p> */}
                                            <p className="ms-2 f-12">
                                                                          {item.issueDate === null ? "" : <>
                                                                            ({moment(item.issueDate).format("DD MMM YYYY")}
                                                                          </>}  
                                                                          {item.expirationDate === null ? "- Present )" : <> 
                                                                            - {moment(item.expirationDate).format("DD MMM YYYY")})
                                                                          </>}  

                                                                        </p>                                      
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>
            }
            {visibleAwards.length === 0 ? '' :
              <div className="UpdateProfile pb-0 p-3 page-break">
                <div className="d-flex justify-content-between mb-2 border-custom2 pb-2">
                  <div className="d-flex">
                    <MilitaryTechSharpIcon className="HeadingIcon material-symbols-sharp" />
                    <p className="f-16 fw-bold ms-1">{t("User Profile.Awards")}</p>
                  </div>
                </div>
                {visibleAwards.map((item, index) => {
                      const isLastItem = index === visibleAwards.length - 1;
                      return (
                        <div
                          className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom1"
                            } pb-2 ${item?.status === 0 ? 'disableText' : ''}`}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            {/* <img src={NewsFeed.companyLogo} alt="" width={40} height={40} /> */}
                            <div className="ms-2">
                              <div className="d-flex verified">
                              <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                <p className="f-14 ms-1 fw-bold me-2">
                                  {item.name && (
                                    <>
                                      {item.name}
                                      {/* {item?.isOrgVrfd === true ? (
                                        <img src={resume.verified} width={18} height={18} className="ms-1" />
                                      ) : item?.isOrgRgd === true ? (
                                        <img src={resume.register} width={18} height={18} className="ms-1" />
                                      ) : (
                                        <img src={resume.unregister} width={18} height={18} className="ms-1" />
                                      )}
                                      {item?.isInstitutionDelete && <img src={resume.deleted} width={15} height={15} />} */}
                                    </>
                                  )}
                                </p>
                              </div>
                              <div className="ms-2">
                                {item.orgName && <p className=" me-1 f-14 fw-bold">{item.orgName}</p>}
                                <div className="d-flex align-items-center">
                                  {item.recognition && <p className=" me-1 f-12">{item.recognition}</p>}
                                </div>
                                {item.description && (
                                  <>
                                    <p className="f-12 fst-italic">{item.description}</p>
                                  </>
                                )}
                                <div className="d-flex align-items-center">
                                  {item.cityName && (
                                    <>
                                      <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                                      <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                      {/* <div className="dot"></div> */}
                                    </>
                                  )}
                                  <p className=" f-12">
                                  <p className="ms-1 f-12">
                                                                          {item.issueDate === null ? "" : <>
                                                                            ({moment(item.issueDate).format("DD MMM YYYY")}
                                                                          </>}  
                                                                          {item.expirationDate === null ? "- Present )" : <> 
                                                                            - {moment(item.expirationDate).format("DD MMM YYYY")})
                                                                          </>}  

                                                                        </p>
                                    {/* ({moment(item.issueDate).format("DD MMM YYYY")} - {moment(item.expirationDate).format("DD MMM YYYY")}) */}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>
            }
            {visibleSkills.length === 0 ? '' :
              <div className="UpdateProfile pb-2 p-3 page-break">
                <div className="d-flex justify-content-between mb-2 border-custom2 pb-2">
                  <div className="d-flex">
                    <PsychologySharpIcon className="HeadingIcon material-symbols-sharp" />
                    <p className="f-16 fw-bold ms-1">{t("User Profile.Skills")}</p>
                  </div>
                </div>
                {/* <div className='analytics d-flex justify-content-between mt-3'> */}
                {visibleSkills.map((item, index) => {
                      const isLastItem = index === visibleSkills.length - 1;
                      return (
                        <div
                          className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom1"
                            } ${item?.status === 0 ? 'disableText' : ''}`}
                          key={index}
                        >
                          <div className="d-flex justify-content-between mb-2">
                            <div className="d-flex align-items-center verified ">
                              <p className="f-16 fw-bold me-1">{index + 1}.</p>
                              <p className="f-14 ms-1 pb-0 fw-bold  me-2">
                                {item.skillName}
                              </p>
                            </div>
                            {/* )} */}
                          </div>
                          <p className="ms-1 f-12">
                            {item.firmIndustryTypeName}
                          </p>
                          {item.endorsedCount && <p className="ms-1 f-12">
                            {/* Frontend Web Developer at HyperautoX Information
                          Technology LLC */}
                            {item.endorsedCount} {t("User Profile.endorsement")}
                          </p>}
                        </div>
                      );
                    })}
              </div>
            }
            {/* {CCVAttachement.length === 0 ? '' :
              <div className="UpdateProfile pb-0 p-3 page-break">
                <div className="d-flex justify-content-between mb-2 border-custom2 pb-2" >
                  <div className="d-flex">
                    <AttachFileSharpIcon className="HeadingIcon material-symbols" />
                    <p className="f-16 fw-bold ms-1">Attachement</p>
                  </div>
                </div>
                {CCVAttachement &&
                  CCVAttachement.filter(item => item?.status !== 0)
                    ?.map((item, index) => {
                      const isLastItem = index === CCVAttachement?.length - 1;
                      return (
                        <div
                          className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom2"
                            } pb-3 ${item?.status === 0 ? 'disableText' : ''}`}
                          key={index}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="ms-2">
                              <div className="d-flex">
                                <p className="f-14 ms-1 pb-1 fw-bold">
                                  {item?.docName}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>
            } */}
          </div>
        )
      }  

            { showToast && (
              <div style={{
                position: "fixed",
                bottom: 20,
                right: 20,
                background: "rgb(145 158 169 / 65%)",
                color: "#333",
                padding: "0", 
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                width: "300px",
                zIndex: 1000,
                overflow: "hidden",
                fontFamily: "Arial, sans-serif"
              }}> 
                <div style={{
                  background: "rgb(68 104 135 / 65%)",
                  padding: "12px 16px",
                  color: "#fff",
                  fontSize: "15px",
                }}>
                  {toastMessage}
                </div>
              </div>
            )}

    </>
  );
};

export default ViewResume;

